import React from "react";
import CssClasses from "./LeaguePicker.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";
import LeagueButton from "../../UI/LeagueButton/LeagueButton";
import * as MostPlayedOptionIDs from "../../../HOCs/Constants/MostPlayedOptionID";

import beepHigh from "../../../assets/sounds/beep_high.mp3";

let _props = null;

const LeaguePicker = props => {
  _props = props;

  //zasad se ne koristi
  return null;

  if (props.activeMostPlayedButtonID !== MostPlayedOptionIDs.TOP_LEAGUES) {
    return null;
  }

  if (!props.leagueItems) {
    return null;
  }

  return (
    <div className="outerContainer">
      <audio
        ref={sound => {
          this.beepHigh = sound;
        }}
      >
        <source src={beepHigh} type="audio/mpeg" />
      </audio>
      <div className={CssClasses.container}>
        {props.leagueItems.map(li => {
          return (
            <LeagueButton
              onButtonClicked={specialOptionButtonClick}
              titleCategory={li.CategoryTitle}
              titleTournament={li.TournamentTitle}
              key={li.TournamentID}
              id={li.TournamentID}
              isActive={li.TournamentID === props.activeLeagueID}
              eventCount={li.EventCount}
              sportID={li.SportID}
            />
          );
        })}
      </div>
    </div>
  );
};

const specialOptionButtonClick = id => {
  console.log("Button click.." + id);

  if (this.beepHigh) {
    this.beepHigh.play();
  }

  _props.onChangeCurrentLeague(id);
};

const mapStateToProps = state => {
  return {
    activeLeagueID: state.rrNavigation.leagueID,
    activeMostPlayedButtonID: state.rrNavigation.mostPlayedButtonID,
    updateTimestamp: state.rrSportEvent.updateTimestamp, //hack da povuce novi state i napravi rerender
    leagueItems: state.rrSportEvent.prematchLeagueItems
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onChangeCurrentLeague: leagueID =>
      dispatch(StoreActions.ChangeLeagueItem(leagueID))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeaguePicker);



// WEBPACK FOOTER //
// ./src/Components/Navigation/LeaguePicker/LeaguePicker.js